import { useEffect } from 'react'
import { FilteractionObject } from '@yes.technology/react-toolkit'

import fetchFilteractions from '../api/fetchFilteractions'
import { useQuery } from '@tanstack/react-query'

type UseObjectClassFilteractionsArgs = {
  objectclassUuid?: string
  filteractionOptions?: FilteractionObject[]
  dependsOnFilteractionOptions?: boolean
}

export default function useObjectClassFilteractions({
  objectclassUuid,
  filteractionOptions,
  dependsOnFilteractionOptions
}: UseObjectClassFilteractionsArgs) {
  const { data, error } = useQuery<FilteractionObject[] | null, Error>({
    queryKey: ['object-class-filteractions', objectclassUuid],
    queryFn: () => {
      return fetchFilteractions(objectclassUuid, false)
    },
    enabled: !!objectclassUuid && !filteractionOptions
  })

  useEffect(() => {
    if (error) console.log(error.message)
  }, [error])

  if (dependsOnFilteractionOptions) return filteractionOptions || []

  return data || []
}
